import React from 'react';
import { TextareaAutosize } from '@mui/material';
import { Coffee, Cookie, Flower2, Sparkles, Star, Sun } from 'lucide-react';
import { MAX_MENU_TITLE_LENGTH, MENU_CATEGORIES, MENU_THEMES } from '../utils/dopamenu';
import './DopamenuPrint.css';

const ICONS = { starters: Sun, mains: Flower2, sides: Coffee, desserts: Cookie, specials: Star };

export default function DopamenuPrint({ menu, drafts, errors = {}, onTitleChange, onCategoryChange }) {
  const colors = MENU_THEMES[menu.theme] || MENU_THEMES.mint;
  return (
    <article className="dopamenu-sheet" style={{ '--menu-paper': colors.paper, '--menu-accent': colors.accent,
      '--menu-secondary': colors.secondary, '--menu-ink': colors.ink }}>
      <header className="dopamenu-sheet-header">
        <span className="dopamenu-sheet-label">A LITTLE JOY, YOUR WAY</span>
        <div className="dopamenu-sheet-title"><Sparkles aria-hidden="true" />
          {onTitleChange ? <TextareaAutosize aria-label="Menu title" className="dopamenu-sheet-title-input" value={menu.title}
            placeholder="My dopamine menu" maxLength={MAX_MENU_TITLE_LENGTH} onChange={(event) => onTitleChange(event.target.value.replace(/\r?\n/g, ' '))} />
            : <h2>{menu.title.trim() || 'My dopamine menu'}</h2>}
          <Sparkles aria-hidden="true" /></div>
        <p>Pick something that feels good to you.</p>
      </header>
      <div className="dopamenu-sheet-courses">
        {MENU_CATEGORIES.map(({ id, title, description, ideas }) => {
          const Icon = ICONS[id];
          const items = menu.items.filter((item) => item.category === id);
          return (
            <section className={`dopamenu-sheet-course dopamenu-sheet-${id}`} key={id}>
              <div className="dopamenu-sheet-course-heading"><Icon aria-hidden="true" /><h3>{title}</h3></div>
              <p>{description}</p>
              {onCategoryChange ? <>
                <TextareaAutosize aria-label={`${title} activities`} className="dopamenu-sheet-activities-input" minRows={3}
                  placeholder={`e.g. ${ideas.join('\n')}`} value={drafts[id]} onChange={(event) => onCategoryChange(id, event.target.value)}
                  aria-invalid={Boolean(errors[id])} aria-describedby={errors[id] ? `${id}-error` : undefined} />
                {errors[id] && <p className="dopamenu-sheet-error" id={`${id}-error`} role="alert">{errors[id]}</p>}
              </> : <ul>
                {items.length ? items.map((item) => <li key={item.id}>{item.title}</li>)
                  : [0, 1, 2].map((line) => <li className="dopamenu-sheet-blank" aria-label="Space for your own idea" key={line}>&nbsp;</li>)}
              </ul>}
            </section>
          );
        })}
      </div>
      <footer className="dopamenu-sheet-footer"><Star aria-hidden="true" /><span>Made with Dopatize · dopatize.com/tools/dopamenu</span><Star aria-hidden="true" /></footer>
    </article>
  );
}
